/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */
 /* eslint-env node */

'use strict';

var adapterFactory = require('./adapter_factory.js');
module.exports = adapterFactory({window: global.window});



//////////////////
// WEBPACK FOOTER
// ./node_modules/webrtc-adapter/src/js/adapter_core.js
// module id = 1867
// module chunks = 0